

export function hapticFeedback(pattern=[]){
    if(navigator.vibrate) {
        navigator.vibrate(pattern)
    }
    return;
}